import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { axiosInstance } from 'src/axios';

import { responseHandler } from '../utils';

type MutationParams = {
    attractionId: string;
};

// v3-deleteAttractions obsługuje 1..N — pojedyncze usunięcie to tablica jednoelementowa
// (§4-D migrationPlan). Body przy DELETE idzie przez `config.data`.
export const useDeleteAttractionFromFirestore = (
  options?: UseMutationOptions<void, AxiosError, MutationParams>,
): UseMutationResult<void, AxiosError, MutationParams> => useMutation<void, AxiosError, MutationParams>({
  mutationFn: ({ attractionId }) => axiosInstance.delete('/v3-deleteAttractions', {
    data: { ids: [attractionId] },
    headers: { 'Content-Type': 'application/json' },
  }).then(responseHandler),
  ...options,
});
